module.exports = __webpack_public_path__ + "img/home_adapt_class_new_normal.6cecbdb0.svg";